import { create } from "zustand";

type State = {
  dataChanges: number | null;
};

type Action = {
  setDataChanges: (trigger: number | null) => void;
};

const useDataChanges = create<State & Action>((set) => ({
  dataChanges: null,
  setDataChanges: (dataChangesTerm) =>
    set(() => ({ dataChanges: dataChangesTerm })),
}));

export default useDataChanges;
